import { render, staticRenderFns } from "./ProvidersSettings.vue?vue&type=template&id=7ad1c06d&"
import script from "./ProvidersSettings.vue?vue&type=script&lang=js&"
export * from "./ProvidersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports